import { Separator } from '@radix-ui/react-separator'


import { cn } from '@/lib/utils'
import { DebugDropdown } from './_dev/dbg-dropdown'
import { SidebarTrigger } from './ui/sidebar'
import { UserAvatar } from './user-avatar'

import { PracticianFinder } from '@/features/finder/components/practician-finder'
import { TechnicianFinder } from '@/features/finder/components/technician-finder'
import { ConnectionsDropdown } from '@/features/invite/components/connections-dropdown'
import { NotificationPopover } from '@/features/notifications/components/notifications-popover'
import { Authorization, ROLES } from '@/lib/authorization'
import { useEffect, useState } from 'react'

type NavbarProps = React.HTMLAttributes<HTMLElement> & {
  fixed?: boolean
  ref?: React.Ref<HTMLElement>
}

export default function Navbar({fixed, ref, children, className, ...props }: NavbarProps) {
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const onScroll = () => {
      setOffset(document.body.scrollTop || document.documentElement.scrollTop)
    }

    document.addEventListener('scroll', onScroll, { passive: true })
    return () => document.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header 
      className={cn(
        'z-50 h-16',
        fixed && 'header-fixed peer/header sticky top-0 w-[inherit]',
        offset > 10 && fixed ? 'shadow' : 'shadow-none',
        className
      )}
      {...props}
    >
      <div
        className={cn(
          'relative flex h-full items-center gap-3 p-4 sm:gap-4',
          offset > 10 &&
            fixed &&
            'after:absolute after:inset-0 after:-z-10 after:bg-background/20 after:backdrop-blur-lg'
        )}
      >
        <SidebarTrigger className='max-md:scale-125' />
        <Separator decorative orientation="vertical" className="h-6 w-[1px] bg-muted-foreground/40" />
        <div className="flex basis-full md:basis-2/5">
          <Authorization allowedRoles={[ROLES.TECHNICIAN]}>
            <TechnicianFinder />
          </Authorization>
          <Authorization allowedRoles={[ROLES.PRACTICIAN]}>
            <PracticianFinder />
          </Authorization>
        </div>
        <Separator decorative orientation="vertical" className="h-6 w-[1px] bg-muted-foreground/40 ml-auto" />
        <ConnectionsDropdown />
        <DebugDropdown />
        <NotificationPopover />
        <UserAvatar />
      </div>
    </header>
  )
}
